import { useEffect } from 'react'
import { useRecoilState, useRecoilValue } from 'recoil'
import { TelecomTypeState } from 'src/recoil/join'
import { PartnerState } from 'src/recoil/ui'

/**
 * GetPartnerInfo 전문에서 받아온 통신사 가입제한 값과 비교해
 * 제한된 통신사를 선택하면 alert후 window.close()
 */
export const useCheckTelecomIsBlock = () => {
  const [TelType, setTelType] = useRecoilState(TelecomTypeState)
  const { SKTJoin, KTJoin, LGUPJoin, JoinBlockMsg } = useRecoilValue(PartnerState)

  useEffect(() => {
    const telecomBlockArr = [SKTJoin === 'Y', KTJoin === 'Y', LGUPJoin === 'Y']

    const dimLayer = document.createElement('div')
    Object.assign(dimLayer.style, {
      position: 'fixed',
      top: '0',
      left: '0',
      width: '100vw',
      height: '100vh',
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      zIndex: '1000',
      pointerEvents: 'none',
    })
    
    if (!telecomBlockArr[TelType]) {
      document.body.appendChild(dimLayer)
      setTimeout(() => {

        alert(JoinBlockMsg)
        window.self.close()
        window.history.back()

        document.body.removeChild(dimLayer)
      }, 200)
    }
  }, [JoinBlockMsg, KTJoin, LGUPJoin, SKTJoin, TelType, setTelType])
}